import {Editor} from '@tiptap/react';
import {AppState} from '../reducer';
import {EditorModeType} from '../actions/types/tiptapEditor.types';

export const editorSelector = (state: AppState, id: string): Editor | null => state.editorReducer.editors[id] || null;

export const debounceChangeHandlerSelector = (state: AppState, id: string): ((updatedContent: string) => void) | null =>
    state.editorReducer.debounceChangeHandlers[id] || null;

export const editorModeSelector = (state: AppState): EditorModeType | null => state.editorReducer.editorMode;
